import { useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/components/DashboardLayout";
import AdminHome from "@/pages/admin/AdminHome";
import StudentHome from "@/pages/student/StudentHome";
import AssociationHome from "@/pages/association/AssociationHome";
import MentorHome from "@/pages/mentor/MentorHome";
import ContentHome from "@/pages/content/ContentValueHome";
import DonorHome from "@/pages/donor/DonorValueHome";
import RecruiterHome from "@/pages/recruiter/RecruiterHome";
import FacultyHome from "@/pages/faculty/FacultyHome";

const HOME_BY_ROLE = {
  super_admin: AdminHome,
  student: StudentHome,
  association: AssociationHome,
  mentor: MentorHome,
  content_creator: ContentHome,
  donor: DonorHome,
  recruiter: RecruiterHome,
  faculty: FacultyHome,
};

export default function DashboardHome() {
  const { user } = useAuth();
  const Comp = HOME_BY_ROLE[user?.role] || StudentHome;
  return (
    <DashboardLayout>
      <Comp />
    </DashboardLayout>
  );
}
